/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'

export const SlackChannel = z.object({ link: z.string(), name: z.string() })

export interface SlackChannel extends z.TypeOf<typeof SlackChannel> {}
